import { Link } from 'react-router-dom';
import { categories } from '@/mocks/products';

interface ProductCardProps {
  id: number;
  name: string;
  description: string;
  price: number;
  originalPrice: number;
  image: string;
  tag?: string;
  badge?: string;
  categorySlug: string;
}

const badgeConfig: Record<string, { bg: string; text: string }> = {
  hot: { bg: 'bg-accent-500', text: 'text-background-50' },
  family: { bg: 'bg-primary-100', text: 'text-primary-700' },
  classic: { bg: 'bg-secondary-100', text: 'text-secondary-700' },
  popular: { bg: 'bg-accent-100', text: 'text-accent-700' },
  recommend: { bg: 'bg-primary-100', text: 'text-primary-700' },
  clean: { bg: 'bg-secondary-100', text: 'text-secondary-700' },
  health: { bg: 'bg-primary-100', text: 'text-primary-700' },
  senior: { bg: 'bg-secondary-100', text: 'text-secondary-700' },
  light: { bg: 'bg-primary-100', text: 'text-primary-700' },
  zero: { bg: 'bg-secondary-100', text: 'text-secondary-700' },
  organic: { bg: 'bg-primary-100', text: 'text-primary-700' },
  protein: { bg: 'bg-accent-100', text: 'text-accent-700' },
};

export default function ProductCard(product: ProductCardProps) {
  const category = categories.find((c) => c.slug === product.categorySlug);
  const badgeStyle = product.badge ? badgeConfig[product.badge] : null;

  return (
    <div className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer" data-product-shop="">
      <Link to={`/category/${product.categorySlug}`} className="block">
        <div className="relative w-full aspect-square overflow-hidden bg-background-100">
          <img
            src={product.image}
            alt={product.name}
            title={`${product.name} - 爱威奶在线正品`}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          />
          {badgeStyle && product.tag && (
            <span className={`absolute top-3 left-3 px-2.5 py-1 rounded-full text-xs font-medium ${badgeStyle.bg} ${badgeStyle.text}`}>
              {product.tag}
            </span>
          )}
        </div>
        <div className="p-4">
          {category && (
            <p className="text-xs text-foreground-500 mb-1">{category.name}</p>
          )}
          <h3 className="text-sm font-medium text-foreground-900 mb-1.5 line-clamp-2 leading-snug">
            {product.name}
          </h3>
          <p className="text-xs text-foreground-500 mb-3 line-clamp-2 leading-relaxed">
            {product.description}
          </p>
          <div className="flex items-center gap-2">
            <span className="text-base font-bold text-accent-600">
              ¥{product.price}
            </span>
            <span className="text-xs text-foreground-400 line-through">
              ¥{product.originalPrice}
            </span>
          </div>
        </div>
      </Link>
    </div>
  );
}